import React, { useEffect, useState, useContext } from 'react';
// import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import GradientButton from '../../../../../customMui/newButton/newButton';
import AvTimerOutlinedIcon from '@mui/icons-material/AvTimerOutlined';
import 'moment-timezone';
import moment from 'moment/moment';
import { useHistory } from 'react-router-dom';
import licArrays from '../../../../libs/licArray';
import getMyLicenses from '../../../../libs/getmylicense';
import userAuthPayloaddata from '../../../../libs/userAuthPayload';
import getAvailableSeats from '../../../../libs/overlapmeeting';
import { Button, InputLabel, MenuItem, Select, TextField, FormControl } from '@material-ui/core';
import ControllerContext from './../../../../../../RoomControllerSocketContext';
import { ConstructionRounded } from '@mui/icons-material';
import { toast } from 'react-toastify';
import callApi from '../../../../libs/callApi';
// import { useIntl } from 'react-intl';
const InstantMeeting = (props) =>
{
	const [ MeetingName, SetMeetingName ] = useState(`${props?.userdetails?.data?.firstName?.trim()}'s Meeting`);
	const { pluginSocket } = useContext(ControllerContext);
	const [ duration, setDuration ] = useState({ hrs: 0, mins: 30 });
	const [ minArray, setMinArray ] = useState([]);
	const [ durationPopup, setDurationPopup ] = useState(false);
	const [ license, setLicense ] = useState('');
	const [ selectedlicense, setselectedlicense ] = useState('');
	const [ defaultLicenseValue, setDefaultLicenseValue ] = useState('');
	const [ validseaterror, setValidSeatError ] = useState('');
	const [ validNameerror, setValidNameError ] = useState('');
	const [ validTimeerror, setValidTimeError ] = useState('');
	const [ displaySeatsOption, setDisplaySeatsOption ] = useState(true);
	const [ availableSeats, setAvailableSeats ] = useState(0);
	const [ licenseType, setLicenseType ] = useState('');
	const [ licenseTypes, setLicenseTypes ] = useState([]);
	const [ licArray, setLicArray ]=useState(licArrays(props?.data));
	const allLicenses = props?.data;
	const userInfo = props?.userdetails?.data;
	const [ userAuthPayload, setUserAuthPayload ]=useState({});

	// const intl = useIntl();

	const [ meetingInfo, setMeetingInfo ] = useState({
		meetingName      : userInfo?.lastName ? `${userInfo?.firstName} ${userInfo?.lastName}'s Meeting` : `${userInfo?.firstName?.trim()}'s Meeting`,
		duration         : 30,
		participantLimit : 2,
		meetingType      : 'inVC',
		scheduledBy      : `${props.userdetails.data.userId}`,
		startTimeUTC     : new Date().getTime(),
		endTimeUTC       : new Date().getTime() + ((duration?.hrs * 3600000) + (duration?.mins * 60000)),
		guestToControl   : true,
		isRecurring      : false,
		scheduleType     : 'insta',
		useinapi         : true,
		extra            : {
			name  : props.userdetails.data.name,
			email : props.userdetails.data.email
		},
		timezone : Intl.DateTimeFormat().resolvedOptions().timeZone
	});

	console.log('licenseTypes', licenseTypes);
	console.log('license', license);
	const navigate = useHistory();
	const handleDurationPopup = () =>
	{
		setDurationPopup(!durationPopup);
	};

	console.log('licArray', licArray);
	console.log('allLicenses', props?.data);
	console.log('userInfo', props?.userdetails?.data);

	useEffect(() =>
	{
		setUserAuthPayload(userAuthPayloaddata(props?.userdetails?.data));
	}, []);

	async function createInstantMeeting()
	{
		props?.setIsLoading(true);
		const data = JSON.stringify({
			'path'    : '/schedule/create',
			'method'  : 'POST',
			'apiBody' : {
				meetingName      : MeetingName,
				duration         : 60 * duration.hrs + duration.mins,
				participantLimit : meetingInfo.participantLimit,
				meetingType      : meetingInfo.meetingType,
				scheduledBy      : userAuthPayload.attributes.sub,
				startTimeUTC     : new Date().getTime(),
				endTimeUTC       : new Date().getTime() + ((duration?.hrs * 3600000) + (duration?.mins * 60000)),
				guestToControl   : meetingInfo.guestToControl,
				isRecurring      : meetingInfo.isRecurring,
				scheduleType     : meetingInfo.scheduleType,
				useinapi         : true,
				extra            : {
					name  : userAuthPayload.attributes.name,
					email : userAuthPayload.attributes.email
				},
				timezone       : Intl.DateTimeFormat().resolvedOptions().timeZone,
				licenseDetails : {
					licenseName : `${selectedlicense?.licenseName}`,
					licenseObj  : selectedlicense?.licenseObj
				},
				licenseId : [ `${selectedlicense?.licenseObj?._id}` ]
			}

		});

		const response = await callApi(data);

		try
		{
			if (response?.status && response?.insertedData?._id && response?.insertedData?.sessionId)
			{
				pluginSocket?.emit('startMeeting', response?.insertedData);

				const meetingType = btoa(response?.insertedData?.scheduleType);

				const uid = btoa(userInfo?.email);

				const displayName = btoa(userInfo?.firstName);

				const { controllerUniqueId, desktopUniqueId } = await window?.electron?.ipcRenderer?.invoke('requestToJoinRoom');

				const volume = await window?.electron?.ipcRenderer?.invoke('getSystemVolume');

				pluginSocket?.emit('receiveSystemVolume', { volume });

				navigate.push(`/${response?.insertedData?.sessionId}?projectId=${import.meta.env.VITE_ProjectId}&uid=${uid}&displayName=${displayName}&meetingType=${meetingType}&pairId=${desktopUniqueId}_${controllerUniqueId}&profileKey=${userInfo?.profileImage?.key ? encodeURIComponent(userInfo?.profileImage?.key) : ''}`);

			}
			console.log('meeting data===', JSON.stringify(response.data));
			props?.setIsLoading(false);
		}
		catch (error)
		{
			console.log(error);
			props?.setIsLoading(false);
		}


	}

	const handleMeetingName = (event) =>
	{
		const inputName = event.target.value.trim();

		if (inputName.length < 2)
		{
			setValidNameError('Meeting Name have atleast two characters');
		}
		else
		{
			setValidNameError('');
		}
		SetMeetingName(inputName);
	};
	const handleMeeting = () =>
	{
		if (availableSeats===0)
		{
			// toast.error(intl.formatMessage({ id: 'Already_used_all_license', defaultMessage: 'Already used all your seats for this license' }));
			toast.error('Already used all your seats for this license');
		}
		else
		{
			createInstantMeeting();
		}
	};
	const displayAvailableSeats = async (lic) =>
	{

		const selectedLicense = licArray.find((each) => each?.licenseName === lic);
		const availableLicense = Number(selectedLicense?.licenseName.split('_')[1]);

		const localTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;

		const dateTime = moment(new Date()).tz(localTZ)
			.toDate();
		const startTime = new Date(moment.utc(dateTime).format()).getTime();
		const endTimeUTC = startTime + (30 * 60000);

		const _license = selectedLicense?.licenseObj?._id;

		console.log('userAuthPayload?.attributes?', userAuthPayload?.attributes);
		const userId = userAuthPayload?.attributes?.sub;

		setMeetingInfo((prevState) => ({
			...prevState,
			licenseId : [ _license ]
		}));

		if (_license)
		{
			props?.setIsLoading(true);
			const seats = await getAvailableSeats(startTime, endTimeUTC, _license, userId, selectedLicense, availableLicense, userAuthPayload);

			if (seats > 0)
			{

				setAvailableSeats(seats);
			}
			else
			{
				setAvailableSeats(0);
			}
			props?.setIsLoading(false);
		}
	};

	useEffect(() =>
	{
		const checkavailableseats = async () =>
		{

			await displayAvailableSeats(license);
		};

		checkavailableseats();
		if (license === 'INVCFREE_100')
		{
			setMinArray([ ...[ 0, 10, 15, 20, 30 ] ]);
		}
		else
		{
			setMinArray([ ...[ 0, 10, 15, 20, 30, 40, 45, 50 ] ]);
		}
	}, [ license ]);

	const handleDurationChange = (e, dur, min) =>
	{
		e.stopPropagation();
		if (dur === 24)
		{
			setDuration((prev) => ({
				...prev,
				hrs  : dur,
				mins : 0
			}));
			setValidTimeError('');
			setDurationPopup(false);
		}
		else
		{
			setValidTimeError('');
			setDuration((prev) => ({
				...prev,
				[e.target.id] : dur
			}));
		}

		if (min)
		{
			if (duration.hrs === 0 && dur === 0)
			{
				setValidTimeError('please select duration atleast 10 min');
			}
			else
			{
				setValidTimeError('');
			}
			setDurationPopup(false);
		}
	};

	useEffect(() =>
	{
		const setLicenseFunc = async () =>
		{
			let defaultLicense;
			// console.log("defaultlicense----",userInfo?.defaultLicense[0]);

			if (userInfo?.defaultLicense[0]!== undefined)
			{
				const arr = licArray?.find((each) => each?.licenseObj?._id === userInfo?.defaultLicense[0]);

				defaultLicense = arr;
				// console.log("defaultlicense----",userInfo?.defaultLicense[0]);
			}
			else
			{
				const highestNumber = Math.max(...licArray?.map((type) => parseInt(type?.licenseName.split('_')[1])));
				const defaultValue = licArray?.find((type) => parseInt(type?.licenseName?.split('_')[1]) === highestNumber);

				defaultLicense = defaultValue;
			}

			if (!defaultLicense?.licenseObj?.isConcurrent)
			{
				setDisplaySeatsOption(false);
				setMeetingInfo((prevState) => ({
					...prevState,
					participantLimit : defaultLicense?.licenseObj?.licenseCount
				}));
			}
			else
			{
				setDisplaySeatsOption(true);
				setMeetingInfo((prevState) => ({
					...prevState,
					participantLimit : 2
				}));
			}
			await displayAvailableSeats(defaultLicense?.licenseName);

			setMeetingInfo((prevState) => ({
				...prevState,
				licenseId : [ defaultLicense?.licenseObj?._id ]
			}));
			// console.log('///////////////////', defaultLicense);
			setselectedlicense(defaultLicense);
			setLicense(defaultLicense?.licenseName);
		};

		setLicenseFunc();
	}, [ licArray ]);

	const handleLicenseType = (event) =>
	{
		// console.log("handle licanse -----",event)
		setLicenseType(event.target.value);
		setMeetingInfo((prevState) => ({
			...prevState,
			meetingType : event.target.value
		}));
		setDefaultLicenseValue('');
	};

	const handleChange = (event) =>
	{

		console.log('event::::::::::;;;', event.target.value);

		setLicense(event.target.value);
		displayAvailableSeats(event.target.value);

		const selectedLicenseId = licArray.find((each) => each?.licenseName === event?.target?.value);

		setselectedlicense(selectedLicenseId);
		console.log('selectedLicenseId:::::::::: ', selectedLicenseId);
		if (!selectedLicenseId?.licenseObj?.isConcurrent)
		{
			setDisplaySeatsOption(false);
			setMeetingInfo((prevState) => ({
				...prevState,
				participantLimit : selectedLicenseId?.licenseObj?.licenseCount
			}));
		}
		else
		{
			setMeetingInfo((prevState) => ({
				...prevState,
				participantLimit : 2
			}));
			setDisplaySeatsOption(true);
		}
	};

	useEffect(() =>
	{
		const invcLicenseData = allLicenses.filter((each) => each?.licenseType === 'inVC');
		const invcProLicenseData = allLicenses.filter((each) => each?.licenseType === 'inVCPro');

		const filteredInvcData = getMyLicenses(invcLicenseData, userInfo);
		const filteredInvcProData = getMyLicenses(invcProLicenseData, userInfo);

		if (licenseType === 'inVC')
		{
			setLicArray(filteredInvcData);
		}
		else
		{
			setLicArray(filteredInvcProData);
		}

	}, [ licenseType, allLicenses, userInfo ]);

	useEffect(() =>
	{

		let defaultLicenseType;

		const lTypeArray = [];

		allLicenses.map((each) =>
		{
			if (!lTypeArray.includes(each?.licenseType))
			{
				lTypeArray.push(each?.licenseType);
			}
		});

		if (defaultLicenseValue)
		{
			allLicenses.map((each) =>
			{
				if (userInfo?.defaultLicense[0] !== '' && each?._id === userInfo?.defaultLicense[0])
				{
					defaultLicenseType = each?.licenseType;
				}
			});
		}
		else
		{
			defaultLicenseType = lTypeArray[0];
		}

		setLicenseTypes(lTypeArray);
		setLicenseType(defaultLicenseType);
		console.log('--------------------------', defaultLicenseValue);
		setMeetingInfo((prevState) => ({
			...prevState,
			meetingType : defaultLicenseType
		}));
	}, [ allLicenses, userInfo?.defaultLicense ]);
	const handleNoOfSeats = (e) =>
	{

		if (Number(e.target.value).toString()?.length <= Number(availableSeats).toString()?.length && Number(e.target.value) <= Number(availableSeats))
		{
			if (/^\d*$/.test(e.target.value))
			{
				setMeetingInfo((prevState) => ({
					...prevState,
					participantLimit : Number(e.target.value)
				}));
			}
			if (Number(e.target.value) === 0 || Number(e.target.value) === 1)
			{
				setValidSeatError('Please enter 2 or more than 2 seats');
			}
			else
			{
				setValidSeatError('');
			}
		}
		else
		{
			setValidSeatError(`Please select from available seats ${availableSeats}`);
		}
	};

	return (
		<div className='flexCol dialogBD'>
			<div className='flexCol dialogBox'>
				<div className='flexRow pdngSM aCntr jBtwn brdrBSM'>
					<span className='mHdng pdngHSM '>Instant Meeting</span>
					<img src='/icons/Cancel.svg' alt='cancel' className='IconImage pointer' onClick={() => props?.setMeet('')} />
				</div>
				<div className='flexCol pdngHMD'>
					<div className='flexCol pdngSM '>
						<TextField
							margin='dense'
							fullWidth
							label='Meeting Name'
							variant='standard'
							value={MeetingName}
							onChange={handleMeetingName}
						/>
						{validNameerror &&
						<small className='errTxt pdngVXXS'>{validNameerror}</small>
						}
						{
							licenseTypes?.length > 1 &&
							<FormControl fullWidth margin='dense' variant='standard'>
								<InputLabel id='demo-simple-select-label'>
									{/* {translate('select_meeting_type')} */}
								</InputLabel>
								<Select
									labelId='demo-simple-select-label'
									id='demo-simple-select'
									value={licenseType || ''}
									label='Select meeting type'
									onChange={handleLicenseType}
								>
									{
										licenseTypes.map((each, index) => (
											<MenuItem key={index} value={each}>{each}</MenuItem>
										))
									}
								</Select>
							</FormControl>
						}

						{(licArray?.length > 1 || licenseTypes?.length > 1) && <FormControl fullWidth margin='dense' variant='standard'>
							<InputLabel id='demo-simple-select-label'>
								{/* {translate('select_license')} */}
							</InputLabel>
							<Select
								labelId='demo-simple-select-label'
								id='demo-simple-select'
								value={license || ''}
								label='Select license'
								onChange={handleChange}
							>
								{
									licArray.map((each, index) => (
										<MenuItem key={index} value={each?.licenseName}>{each?.licenseName}</MenuItem>
									))
								}
							</Select>
						</FormControl>}
						<div className='flexMinWidthCol jCntr positionRelative pointer' onClick={handleDurationPopup}>
							<div className='flexRow aCntr whiteBg mrgnTMD  brdrBSMC'>
								<div className='flexMinWidthRow'>
									{
										duration?.hrs > 0 &&
										<span className='pdngRSM'>{duration?.hrs} hrs</span>
									}
									<span>{duration?.mins} mins</span>
								</div>
								<div className='flexAutoCol pdngXS'>
									<AvTimerOutlinedIcon style={{ color: 'grey' }} />
								</div>
							</div>
							{
								durationPopup &&
								<div className='flexRow aEnd jEnd'>
									<div className='flexCol durations' >
										<div className='flexRow fullH'>
											{license !== 'INVCFREE_100' && <div className='flexMinWidthCol aCntr pdngXXS'>
												<b className='durationHeading'>hrs</b>
												<div className='flexCol aCntr durationHrsMins'>
													{
														[ ...Array(25) ].map((each, index) => (
															<span key={index} id='hrs' onClick={(e) => handleDurationChange(e, index)} className={`fullW flexCol aCntr pdngXS pointer ${index === duration?.hrs && 'durationSelected'}`}>{index < 10 ? `0${index}` : index}</span>
														))
													}
												</div>
											</div>}
											<div className={`flexMinWidthCol aCntr pdngXXS ${duration?.hrs === 24 && 'disable'}`}>
												{/* <b className='durationHeading'>{translate("instavc_min_text")}</b> */}
												<div className='flexCol aCntr durationHrsMins'>
													{
														minArray.map((each, index) => (
															<span key={index} id='mins' onClick={(e) => handleDurationChange(e, each, true)} className={`fullW flexCol aCntr pdngXS pointer ${each === duration?.mins && 'durationSelected'}`}>{each < 10 ? `0${each}` : each}</span>
														))
													}
												</div>
											</div>
										</div>
									</div>
								</div>
							}

						</div>
						{
							validTimeerror &&
							<small className='errTxt pdngVXXS'>{validTimeerror}</small>
						}
						{displaySeatsOption && <div className='flexCol pdngTMD'>
							<div className='flexRow brdrBSMC aEnd jBtwn'>
								<span className='pdngVXS'>{('No.of Seats')} ({availableSeats} {(' available')}) </span>
								<input type='text' placeholder='00' className='stNmb'
									value={meetingInfo?.participantLimit}
									onChange={handleNoOfSeats}
								/>
							</div>
						</div>}
						{/* min='0' max={props?.data[0]?.licenseCount} value={seats} */}
						{validseaterror &&
						<small className='errTxt pdngVXXS'>{validseaterror}</small>
						}

					</div>
					<div className='flexRow aEnd jEnd mrgnVLG gap16'>
						<Button
							variant='outlined'
							disableElevation
							style={{ borderRadius: '10px' }}
							onClick={() => props?.setMeet('')}
						>
							Cancel
						</Button>
						<GradientButton
							variant='contained'
							disableElevation
							disabled={MeetingName.length < 2 || meetingInfo.participantLimit < 2 || (60 * duration.hrs + duration.mins) === 0 || !license}
							onClick={handleMeeting}
						>
							Start Meeting
							{/* {translate('start_meeting')} */}
						</GradientButton>
					</div>
				</div>
			</div>
		</div>
	);
};

export default InstantMeeting;
